import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { LOGIN_SCHEMA } from '../../utils/login.js';
import { useLoginMutation } from '../../api/auth.js';
import { useErrors } from '../../hooks/useErrors.js';
import GuestLayout from '../../components/layout/GuestLayout.jsx';
import BaseInput from '../../components/form/BaseInput.jsx';
import BaseButton from '../../components/form/BaseButton.jsx';
import BaseLink from '../../components/misc/BaseLink.jsx';
import { useErrorToast } from '../../hooks/useToast.jsx';

const Login = () => {
    const [login, { isLoading, error }] = useLoginMutation();
    const location = useLocation();
    const initialized = useRef(false);

    const { handleSubmit, getValues, formState, control, clearErrors } = useForm({
        resolver: yupResolver(LOGIN_SCHEMA),
        defaultValues: {
            email: '',
            password: ''
        },
        reValidateMode: 'onSubmit'
    });

    const { errors } = useErrors(error?.message, formState);

    const sendLogin = async (requestData) => {
        await login({
            email: requestData.email,
            password: requestData.password
        });
    };

    const formValues = getValues();

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            if (location.state?.from?.pathname === '/verify-email') {
                useErrorToast('Please open verify email address link in the browser you are authenticated!');
            }
        }
    }, [location.state?.from?.pathname]);

    return (
        <GuestLayout title='Sign In'>
            <div className='mb-10'>
                <BaseInput
                    type='text'
                    control={control}
                    placeholder='Email'
                    name='email'
                    clearErrors={clearErrors}
                    errors={[...(errors?.email ? errors.email : [])]}
                />

                <BaseInput
                    className='mt-4'
                    type='password'
                    control={control}
                    placeholder='Password'
                    name='password'
                    clearErrors={clearErrors}
                    errors={[...(errors?.password ? errors.password : [])]}
                />

                <BaseButton
                    id='btn-submit'
                    className='mt-10 btn-primary-white'
                    onClick={handleSubmit(sendLogin)}
                    isLoading={isLoading}
                    textValue='Sign In'
                    disabled={!formValues.email || !formValues.password}
                />
            </div>
            <div className='mb-4 flex justify-center'>
                <BaseLink className='btn-link-guest-white' to='/register'>
                    Create new account
                </BaseLink>
            </div>
            <div className='flex justify-center'>
                <BaseLink className='btn-link-guest-white' to='/forgot-password'>
                    Forgot your password?
                </BaseLink>
            </div>
            <div className='flex items-center justify-center gap-3 mt-4'>
                <Link to='/privacy-policy' className='text-white text-xs'>
                    Privacy Policy
                </Link>
                <span className='inline-block w-[5px] h-[5px] bg-white rounded-full'></span>
                <Link to='/terms-and-conditions' className='text-white text-xs'>
                    Terms and conditions
                </Link>
            </div>
        </GuestLayout>
    );
};
export default Login;
